import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SolicitudCompanyLoanComponent } from './solicitud-company-loan.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [SolicitudCompanyLoanComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    MatTableModule,
    ReactiveFormsModule
  ],
  exports: [SolicitudCompanyLoanComponent],
})
export class SolicitudCompanyLoanModule {}
